import React, { useCallback, useEffect } from 'react';
import { TrackingUtils } from '../TrackingUtils';

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const buildTracking = (id, htmlEventIdProp) => {
    if (!id && !htmlEventIdProp) {
        return;
    }

    if (!id) {
        id = htmlEventIdProp;
    }

    return { id: `home-${id}` };
};

export const withClickTrack = (Component, id) => {
    const TrackedComponent = ({ onClick, ...props }) => {
        const onClickDecorated = useCallback(
            (...args) => {
                const htmlEventIdProp = props['html-event-id'];
                const trackingObj = buildTracking(id, htmlEventIdProp);

                if (trackingObj) {
                    TrackingUtils.trackClickEvent(trackingObj);
                }

                return onClick?.(...args);
            },
            [onClick],
        );
        return <Component {...props} onClick={onClickDecorated} />;
    };
    TrackedComponent.displayName = `withClickTrack(${getDisplayName(Component)})`;
    return TrackedComponent;
};

export const withTrackComponentDisplayed = (Component, id) => {
    const TrackedComponent = (props) => {
        useEffect(() => {
            const trackingObj = buildTracking(id, props['html-event-id']);
            let retry = 0;

            const interval = setInterval(() => {
                if (window.__htmlEvents__ && Object.keys(window.__htmlEvents__).length > 0) {
                    if (trackingObj) {
                        TrackingUtils.trackComponentDisplayed(trackingObj);
                        clearInterval(interval);
                    }
                }
                if (++retry === TrackingUtils.MAX_ATTEMPTS) clearInterval(interval);
            }, TrackingUtils.ATTEMPT_TIMEOUT);

            // eslint-disable-next-line
        }, []);
        return <Component {...props} />;
    };
    TrackedComponent.displayName = `withTrackComponentDisplayed(${getDisplayName(Component)})`;
    return TrackedComponent;
};
